import { CLIENT_LEDGER_ENTRY_TYPES } from "./clientLedgerTypes";

export function createClientLedgerEntryKey(date, type, uniqueSuffix) {
  return `${date}#${type}#${uniqueSuffix}`;
}

function parseAmount(value) {
  const amount = Number(value);
  return Number.isFinite(amount) ? amount : null;
}

export function validateClientLedgerEntry(entry) {
  const errors = {};
  const amount = parseAmount(entry.amount);

  if (!entry.clientId) errors.clientId = "Klient jest wymagany.";
  if (!entry.date) errors.date = "Data jest wymagana.";
  if (amount === null) errors.amount = "Kwota musi byc liczba.";

  if (entry.type === CLIENT_LEDGER_ENTRY_TYPES.PAYMENT) {
    if (!entry.method) errors.method = "Metoda platnosci jest wymagana.";
    if (amount !== null && amount <= 0) errors.amount = "Kwota wplaty musi byc dodatnia.";
  }

  if (entry.type === CLIENT_LEDGER_ENTRY_TYPES.MONTHLY_CHARGE) {
    errors.type = "Naliczenie miesieczne jest tworzone przez raport.";
  }

  return errors;
}

export function normalizeClientLedgerEntry(entry, uniqueSuffix) {
  const entryKey = entry.entryKey || createClientLedgerEntryKey(entry.date, entry.type, uniqueSuffix);

  return {
    ...entry,
    amount: Number(entry.amount),
    entryKey,
    id: entry.id || `${entry.clientId}#${entryKey}`,
    method: entry.method || "",
    note: entry.note || "",
    settlementMonth: entry.settlementMonth || "",
  };
}
